module.exports = __webpack_public_path__ + "img/btn_google_signin_light_pressed_web.2a0f1fb2.png";